module.exports = __webpack_public_path__ + "static/media/icep.7c825679.png";